module.exports = __webpack_public_path__ + "static/cod-07d1b5375879d36327303c6b8d12f73b.png";